import { type DependencyList, useMemo } from 'react';
import type { BannerDefinition } from '../banner.types';
import { useConditionalBanner } from './useConditionalBanner';

/**
 * Memoizes a banner definition and registers/removes it based on `active`.
 * The `factory` is re-invoked whenever `deps` change; the resulting object
 * reference is stable in between so it can safely be used as a `useEffect`
 * dependency inside {@link useConditionalBanner}.
 */
export function useBannerRegistration(active: boolean, factory: () => BannerDefinition, deps: DependencyList) {
  // biome-ignore lint/correctness/useExhaustiveDependencies: deps are owned by the caller
  const definition = useMemo(factory, deps);
  useConditionalBanner(active, definition);
}
